exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3WfQG{text-align:center;height:100%;background-color:#fff}body.reader-night-mode ._3WfQG{background-color:#3d3d3d}._2MMKQ{position:absolute;width:210px;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}._3nVTv{width:100%}._1zoXW{display:inline-block;margin:40px 0;font-size:16px;color:#595959}body.reader-night-mode ._1zoXW{color:#b3b3b3}.jBc_o{width:100%;height:40px;margin-bottom:20px;font-size:16px;border-radius:20px}.jBc_o:last-child{margin-bottom:0}.jBc_o+.jBc_o{margin-left:0}", ""]);

// exports
exports.locals = {
	"wrap": "_3WfQG",
	"content": "_2MMKQ",
	"img": "_3nVTv",
	"desc": "_1zoXW",
	"btn": "jBc_o"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/pages/ForbiddenPage/ForbiddenPage.scss
// module id = OLkl
// module chunks = 2